'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$160() {
  this.c1B = null;
  this.c1C = false;
}
export { $c_Lpresto_types$$anon$160 as $c_Lpresto_types$$anon$160 };
$p = $c_Lpresto_types$$anon$160.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$160;
/** @constructor */
function $h_Lpresto_types$$anon$160() {
}
export { $h_Lpresto_types$$anon$160 as $h_Lpresto_types$$anon$160 };
$h_Lpresto_types$$anon$160.prototype = $p;
$p.P = (function() {
  if ((!this.c1C)) {
    this.c1B = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T1($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.c1C = true;
  }
  return this.c1B;
});
var $d_Lpresto_types$$anon$160 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$160, "presto.types$$anon$160", ({
  Yt: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_types$$anon$160 as $d_Lpresto_types$$anon$160 };
//# sourceMappingURL=presto.types$$anon$160.js.map
